import type { App } from 'vue'
import type { Router } from 'vue-router'

import { initWebVitals } from '@/lib/oTel/webVitals'

export function installWebVitals(app: App, router?: Router) {
  const getRoute = () =>
    router
      ? router.currentRoute.value?.matched?.[0]?.path ||
        router.currentRoute.value?.path
      : undefined
  initWebVitals(getRoute)
}
